import { ErrorMessage, useFormikContext } from 'formik';
import _ from 'lodash';
import styled from 'styled-components';

import { Breakpoint } from '../../helpers';

const Container = styled.div`
	color: ${(props) => props.theme.colors.danger};
	padding-top: 6px;

	@media screen and (max-width: ${Breakpoint.Small}) {
		font-size: 13px;
	}
`;

const Element = styled(ErrorMessage)``;

interface IProps {
	name: string;
	validationMessage?: string;
}

export function FieldErrorMessage({ name, validationMessage }: IProps) {
	const { errors } = useFormikContext();

	// Do not try to render formik errors when the errors are in an array
	// This can happen for example while validating min/max array length.
	// You want the error for the min/max length, but not the error for the
	// underlying elements in the array
	if (errors != null && Array.isArray(_.get(errors, name))) {
		if (validationMessage) {
			return <Container>{validationMessage}</Container>;
		}

		return null;
	}
	return (
		<Container>
			<Element name={name} component="div" />
		</Container>
	);
}
